var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgProfileIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 40,
    cy: 40,
    r: 39.5,
    fill: "#F2F2F2",
    stroke: "#C6C6C6"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M48 34.25C48 46.2425 30 46.2425 30 34.25H34.5C34.5 40.2575 43.5 40.2575 43.5 34.25M57 54.5V61.25H21V54.5C21 48.4925 32.9925 45.5 39 45.5C45.0075 45.5 57 48.4925 57 54.5ZM52.725 54.5C52.725 53.06 45.6825 49.775 39 49.775C32.3175 49.775 25.275 53.06 25.275 54.5V56.975H52.725M40.125 18.5C40.755 18.5 41.25 18.995 41.25 19.625V26.375H43.5V20.75C45.0923 21.4869 46.4264 22.6854 47.3292 24.19C48.2319 25.6946 48.6616 27.4357 48.5625 29.1875C48.5625 29.1875 50.1375 29.5025 50.25 32H27.75C27.75 29.5025 29.4375 29.1875 29.4375 29.1875C29.3384 27.4357 29.7681 25.6946 30.6708 24.19C31.5736 22.6854 32.9077 21.4869 34.5 20.75V26.375H36.75V19.625C36.75 18.995 37.245 18.5 37.875 18.5",
    fill: "#0D9C7A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfileIcon);
export default __webpack_public_path__ + "static/media/profileIcon.89210e3da6018a0ca6214f8b17d52191.svg";
export { ForwardRef as ReactComponent };